import classes from './Button.module.scss';

export const customs = { primary: 'primary', secondary: 'secondary', tertiary: 'tertiary', quaternary: 'quaternary' };
export const sizes = { sm: 'sm', md: 'md', lg: 'lg' };
export const colors = { blue: 'blue', purple: 'purple', gray: 'gray' };
export const iconPositions = { left: 'left', right: 'right' };

const Button = ({
  className,
  classNameIcon,
  onClick,
  name,
  custom = customs.primary,
  color = colors.blue,
  size = sizes.md,
  Icon,
  iconPosition = iconPositions.left,
  enabled = true,
  selected = false,
  type,
  form,
  children,
  title
}) => {
  const containerClasses = [classes.standard, classes[custom], classes[color], classes[size]];
  className && containerClasses.push(className);

  const containerClassesIcon = [classes.icon, classes[`icon-${iconPosition}`]];
  classNameIcon && containerClassesIcon.push(classNameIcon);

  selected && containerClasses.push(classes.selected);

  return (
    <button
      title={title}
      form={form}
      name={name}
      className={containerClasses.join(' ')}
      onClick={onClick}
      type={type || 'button'}
      disabled={!enabled}>
      {Icon && <Icon className={containerClassesIcon.join(' ')} />}
      {children}
    </button>
  );
};

export default Button;
